"use client";
import React, { useState, useEffect } from "react";
import dynamic from "next/dynamic";
import Link from "next/link";
import { useSearchParams } from "next/navigation";
import { KeyNames } from "@packages/lib/utlils/filters/filterJson";
import { generatePathName } from "@packages/lib/utlils/filters/result-filters";
import { useFilterContext } from "@packages/lib/utlils/use-context/filter-context";
const LocationSvg = dynamic(() => import("./location-svg"), { ssr: false });
const LocationcheckBox = ({ childItem, formUrl, locationclicked }: any) => {
  const keyName = KeyNames();
  const { selectedLocation, slug, prepopulateFilter, locationState } =
    useFilterContext();
  const searchparams = useSearchParams();
  const [isChecked, setIsChecked] = useState<any>(false);

  useEffect(() => {
    const regionKeys = searchparams.getAll(keyName?.location);
    setIsChecked(
      locationState?.appliedChildRegion?.includes(childItem?.regionTextKey) ||
        regionKeys.includes(childItem?.regionTextKey)
    );
  }, [prepopulateFilter?.location, searchparams]);

  return (
    <>
      {childItem && (
        <div className="form_check relative m-[0_0_12px_24px]">
          <div className="flex items-start gap-[8px]">
            <div className="checkbox_card">
              <Link
                className="hidden"
                id={keyName?.location + childItem?.regionTextKey}
                href={{
                  pathname: generatePathName(slug, keyName?.location),
                  query: formUrl(keyName?.location, childItem?.regionTextKey),
                }}
              >
                {childItem?.regionName}
              </Link>
              <input
                disabled={selectedLocation === "city"}
                type="checkbox"
                checked={isChecked}
                className="form-checkbox hidden"
                id={childItem?.regionName}
                onChange={() => {
                  if (selectedLocation === "city") return;
                  setIsChecked(!isChecked);
                  locationclicked(childItem?.regionTextKey);
                }}
              />
              <label
                htmlFor={childItem?.regionName}
                className="flex justify-center items-center w-[16px] h-[16px] rounded-[3px] border-2 border-grey-600 my-[2px] group-checked:bg-primary-400 cursor-pointer"
              >
                <LocationSvg />
              </label>
            </div>
            <label
              htmlFor={childItem?.regionName}
              className="check-label small font-normal text-grey300 w-[calc(100%_-_28px)]"
            >
              {childItem?.regionName}
            </label>
          </div>
        </div>
      )}
    </>
  );
};
export default LocationcheckBox;
